<div fxLayout="column" fxFlex fxLayoutAlign="center center center" style="margin-top:45px;">
    <!--        1st info row-->
    <div fxLayout="row wrap" fxFlex class="basicInfoSection" fxLayoutGap="10px">
        <div>
            <div fxLayoutAlign="start center center">
                <span fxFlex="grow">Όνομα</span>
                <mat-icon [matTooltip]="firstNameHelpHint">help_outline</mat-icon>
            </div>
            <div style="margin-top:5px;">
                <mat-form-field appearance="outline" fxFlex="grow">
                    <label>
                        <input matInput [(ngModel)]="user.first_name" readonly>
                    </label>
                </mat-form-field>
            </div>
            <div *ngIf="firstNameErrorMessage" class="errorMessage">{{firstNameErrorMessage}}</div>
        </div>

        <div>
            <div fxLayoutAlign="start center center"><span fxFlex="grow">Επώνυμο</span>
                <mat-icon [matTooltip]="lastNameHelpHint">help_outline</mat-icon>
            </div>
            <div style="margin-top:5px;">
                <mat-form-field appearance="outline" fxFlex="grow">
                    <label>
                        <input matInput [(ngModel)]="user.last_name" readonly>
                    </label>
                </mat-form-field>
            </div>
            <div *ngIf="lastNameErrorMessage" class="errorMessage">{{lastNameErrorMessage}}</div>
        </div>

    </div>

    <!--        2nd info row-->
    <div fxLayout="row wrap" fxFlex="grow" class="basicInfoSection"  fxLayoutGap="10px">

        <div >
            <div fxLayoutAlign="start center center"><span fxFlex="grow">Email</span>
                <mat-icon [matTooltip]="emailHelpHint">help_outline</mat-icon>
            </div>
            <div style="margin-top:5px;">
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-select *ngIf="mode !== 'preview'" [(ngModel)]="user.email" disabled>
                        <mat-option *ngFor="let email of getEmailOptions()" [value]="email">{{email}}</mat-option>
                    </mat-select>
                    <input matInput disabled *ngIf="mode=== 'preview'" [value]="getEmailOptions()">
                </mat-form-field>
            </div>
            <div *ngIf="emailErrorMessage" class="errorMessage">{{emailErrorMessage}}</div>
        </div>

        <div>
            <div fxLayoutAlign="start center center"><span fxFlex="grow">Κωδικός σύνδεσης</span>
                <mat-icon [matTooltip]="passwordHelpHint">help_outline</mat-icon>
            </div>
            <div style="margin-top:5px;">
                <mat-form-field appearance="outline" style="width:100%;">
                    <label>
                        <input disabled matInput type="password" [(ngModel)]="user.password">
                    </label>
                </mat-form-field>
            </div>
            <div *ngIf="passwordErrorMessage" class="errorMessage">{{passwordErrorMessage}}</div>
        </div>

    </div>

    <!--        3rd info row-->
    <div fxLayout="row wrap" fxFlex="grow" class="basicInfoSection"  fxLayoutGap="10px">

        <div>
            <div fxLayoutAlign="start center center"><span fxFlex="grow">Τηλέφωνο</span>
                <mat-icon [matTooltip]="phoneHelpHint">help_outline</mat-icon>
            </div>
            <div style="margin-top:5px;">
                <mat-form-field appearance="outline" style="width:100%;">
                    <label>
                        <input disabled matInput [(ngModel)]="user.telephone">
                    </label>
                </mat-form-field>
            </div>
            <div *ngIf="phoneErrorMessage" class="errorMessage">{{phoneErrorMessage}}</div>

        </div>

        <div>
            <div fxLayoutAlign="start center center"><span fxFlex="grow">Πάροχος ειδοποιήσεων</span>
                <mat-icon [matTooltip]="providersHelpHint">help_outline</mat-icon>
            </div>
            <div style="margin-top:5px;">
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-select [(ngModel)]="user.notification_providers">
                        <mat-option *ngFor="let provider of providers"
                                    [value]="provider">{{provider.description}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="providerErrorMessage" class="errorMessage">{{providerErrorMessage}}</div>

        </div>

    </div>


    <!--        Update button-->
    <div fxLayout="row" fxFlex="grow" fxLayoutGap="10px" class="basicInfoSection" fxLayoutAlign.lt-md="center stretch"
         fxLayoutAlign.gt-sm="end center center">
        <button (click)="validate()" fxFlex.lt-md="100" mat-raised-button
                style="color:white; background-color: var(--primary);">Ενημέρωση στοιχείων
        </button>
    </div>
    <!---->

</div>
